import WallFactory from './wall-factory';
import AreaFactory from './area-factory';
import SeparatorFactory from './separator-factory';

export {
  WallFactory,
  AreaFactory,
  SeparatorFactory,
};

export default {
  WallFactory,
  AreaFactory,
  SeparatorFactory,
};
